export enum EAction {
  CHECK = 'CHECK',
  FOLD = 'FOLD',
  RAISE = 'RAISE',
  CALL = 'CALL',
  ALL_IN = 'ALL_IN',
  BET = 'BET',
}
